import ValidationEvent from './ValidationEvent';

export default class ValidationEventImpl<T> implements ValidationEvent<T> {
  target: T;
  isValid: boolean = false;

  constructor(target: T) {
    this.target = target;
  }
}